export const LESSONPLAN_GET_MULTIPLE =  "LESSONPLAN_GET_MULTIPLE"
export const LESSONPLAN_GET_DROPDOWNS =  "LESSONPLAN_GET_DROPDOWNS"
export const LESSONPLAN_GET_ONE =  "LESSONPLAN_GET_ONE"
export const LESSONPLAN_REGISTER_SUCCESS =  "LESSONPLAN_REGISTER_SUCCESS"
export const LESSONPLAN_REGISTER_FAIL =  "LESSONPLAN_REGISTER_FAIL"
export const LESSONPLAN_LOADING =  "LESSONPLAN_LOADING"
export const LESSONPLAN_LOADING_ERROR =  "LESSONPLAN_LOADING_ERROR"
export const LESSONPLAN_ACTIVATE_FAIL =  "LESSONPLAN_ACTIVATE_FAIL"
export const LESSONPLAN_ACTIVATE_SUCCESS =  "LESSONPLAN_ACTIVATE_SUCCESS"
export const LESSONPLAN_UPDATE_SUCCESS =  "LESSONPLAN_UPDATE_SUCCESS"
export const LESSONPLAN_UPDATE_FAIL =  "LESSONPLAN_UPDATE_FAIL"
export const LESSONPLAN_DELETE_SUCCESS =  "LESSONPLAN_DELETE_SUCCESS"
export const LESSONPLAN_DELETE_FAIL =  "LESSONPLAN_DELETE_FAIL"
export const LESSONPLAN_EDIT =  "LESSONPLAN_EDIT"